import styled from 'styled-components';

export const DocumentCanvasWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background: ${(props) => props.theme.colors.background || '#FFFFFF'};
  border-radius: 12px;
  overflow: hidden;
`;

export const DocumentHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px 20px;
  background: ${(props) => props.$bgColor || props.theme.colors.backgroundSecondary || '#F5F7FA'};
  border-bottom: 1px solid ${(props) => props.theme.colors.border || '#E5E7EB'};
`;

export const DocumentTitleInput = styled.input`
  font-size: 20px;
  font-weight: 700;
  color: ${(props) => props.theme.colors.text || '#1F2937'};
  border: none;
  background: transparent;
  outline: none;
  padding: 4px 8px;
  border-radius: 4px;
  transition: background 0.2s ease;

  &:hover {
    background: ${(props) => props.theme.colors.backgroundSecondary || 'rgba(0, 0, 0, 0.05)'};
  }

  &:focus {
    background: ${(props) => props.theme.colors.background || '#FFFFFF'};
    box-shadow: 0 0 0 2px ${(props) => props.theme.colors.primary || '#4F46E5'};
  }
`;

export const DocumentMetadata = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const MetadataItem = styled.span`
  font-size: 13px;
  color: ${(props) => props.theme.colors.textSecondary || '#6B7280'};
  font-weight: 500;
`;

export const TagsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
`;

